const RequiredInputs = ({inputs}: IRequiredInputsProps) => {
  return (
    <div className="flex mt-3 justify-between">
      <p className=" text-gray-6">نهاده‌های مورد نیاز:</p>
      <p className=" text-gray-6">{inputs}</p>
    </div>
  );
};

export default RequiredInputs;
